import React from 'react';

import { Autocomplete, TextField } from '@mui/material';

import { PropertyMappingMethod } from '~/services/AccommodationService';

export const PROPERTY_MAPPING_METHOD_OPTIONS: ReadonlyArray<{ value: PropertyMappingMethod; label: string }> = [
  { value: 'manual', label: 'Manual' },
  { value: 'heuristic', label: 'Heuristic' },
  { value: 'ml_jaccard_agree', label: 'ML + name agree' },
  { value: 'ml_only', label: 'ML only' },
];

export function mappingMethodLabel(method: PropertyMappingMethod): string {
  return PROPERTY_MAPPING_METHOD_OPTIONS.find((option) => option.value === method)?.label ?? method;
}

export function isPropertyMappingMethod(value: string): value is PropertyMappingMethod {
  return PROPERTY_MAPPING_METHOD_OPTIONS.some((option) => option.value === value);
}

const VALUES = PROPERTY_MAPPING_METHOD_OPTIONS.map((option) => option.value);

interface Props {
  value: Array<PropertyMappingMethod>;
  onChange: (newValue: Array<PropertyMappingMethod>) => void;
  onFocus?: () => void;
}

export default function AccommodationMappingMethodFilterInput({ value, onChange, onFocus }: Props) {
  return (
    <Autocomplete
      multiple
      options={VALUES}
      value={value}
      getOptionLabel={mappingMethodLabel}
      onChange={(_, newValue) => onChange(newValue)}
      renderInput={(params) => <TextField {...params} label="Mapping method" onFocus={onFocus} />}
      fullWidth
      openOnFocus
      clearOnEscape
    />
  );
}
